import { render, staticRenderFns } from "./sub3_detail.vue?vue&type=template&id=e8978800&"
import script from "./sub3_detail.vue?vue&type=script&lang=js&"
export * from "./sub3_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports